import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import AppLayout from "../components/Layout/AppLayout";
import LoginPage from "../pages/LoginPage";
import EventListPage from "../pages/EventListPage";
import EventFormPage from "../pages/EventFormPage";
import TicketUploadListPage from "../pages/TicketUploadListPage";
import TicketUploadCreatePage from "../pages/TicketUploadCreatePage";
import TicketListPage from "../pages/TicketListPage";
import TapLogListPage from "../pages/TapLogListPage";
import AuditTrailPage from "../pages/AuditTrailPage";
import SourceChannelListPage from "../pages/SourceChannelListPage";
import SourceChannelFormPage from "../pages/SourceChannelFormPage";
import DashboardPage from "../pages/DashboardPage";
import { selectIsAuthenticated } from "../store/slices/authSlice";

const ProtectedRoute = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route element={<ProtectedRoute />}>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/events" element={<EventListPage />} />
        <Route path="/events/new" element={<EventFormPage mode="create" />} />
        <Route path="/events/:eventId/edit" element={<EventFormPage mode="edit" />} />
        <Route path="/tickets" element={<TicketListPage />} />
        <Route path="/tap-logs" element={<TapLogListPage />} />
        <Route path="/audit-trail" element={<AuditTrailPage />} />
        <Route path="/ticket-uploads" element={<TicketUploadListPage />} />
        <Route path="/ticket-uploads/new" element={<TicketUploadCreatePage />} />
        <Route path="/source-channels" element={<SourceChannelListPage />} />
        <Route
          path="/source-channels/new"
          element={<SourceChannelFormPage mode="create" />}
        />
        <Route
          path="/source-channels/:sourceChannelId/edit"
          element={<SourceChannelFormPage mode="edit" />}
        />
      </Route>
    </Route>
    <Route path="*" element={<Navigate to="/dashboard" replace />} />
  </Routes>
);

export default AppRoutes;
